import * as Yup from "yup";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {PasswordField} from "@/components/form/fields/PasswordField/PasswordField.tsx";
import {PhoneField} from "@/components/form/fields/PhoneField.tsx";
import {PaymentMethodFormValues} from "@/pages/billing/payment-method/PaymentMethodForm.tsx";

export interface AccountInfoFormValues extends PaymentMethodFormValues {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone?: string;
  company: string;
}

export const AccountInfoFormSchema = Yup.object({
  first_name: Yup.string().required("This field cannot be blank."),
  last_name: Yup.string().required("This field cannot be blank."),
  email: Yup.string().email("Please enter a valid email.").required("This field cannot be blank."),
  password: Yup.string().required("This field cannot be blank."),
  company: Yup.string().required("This field cannot be blank."),
});

export const AccountInfoForm = () => {
  return (
    <div className="row row-gap-3">
      <div className="col-12 col-lg-6">
        <InputField
          name="first_name"
          label="First Name"
          placeholder="First Name"
          required={true}
          dataTestId="firstname"
        />
      </div>
      <div className="col-12 col-lg-6">
        <InputField name="last_name" label="Last Name" placeholder="Last Name" required={true} dataTestId="lastname" />
      </div>
      <div className="col-12 col-lg-6">
        <InputField name="email" label="Email" placeholder="Email" required={true} type="email" dataTestId="email" />
      </div>
      <div className="col-12 col-lg-6">
        <PasswordField name="password" label="Password" placeholder="Password" required={true} dataTestId="password" />
      </div>
      <div className="col-12 col-lg-6">
        <PhoneField disableDialCodeAndPrefix={true} name="phone" label={"Phone"} placeholder={"Phone (for alerts)"} />
      </div>
      <div className="col-12 col-lg-6">
        <InputField name="company" label="Company" placeholder="Company" required={true} />
      </div>
    </div>
  );
};
